export type ManagementBuildingCostType =
  | "基本経費情報"
  | "固定資産税・都市計画税"
  | "消耗品費"
  | "設備修繕、大規模修繕費用"
  | "その他一過性の支出";

export const getManagementBuildingCostTypeKey = (costType: ManagementBuildingCostType): string => {
  const costTypeKeyMap: Record<ManagementBuildingCostType, string> = {
    基本経費情報: "property_tax", // 基本経費情報は固定資産税にマッピング
    "固定資産税・都市計画税": "property_tax",
    消耗品費: "supplies_cost",
    "設備修繕、大規模修繕費用": "large_scale_repair_fund_cost",
    その他一過性の支出: "misc_onetime_cost",
  };
  return costTypeKeyMap[costType];
};
